import { FC, useEffect, useState } from 'react';
import SeatLayout from './SeatLayout';
import AuthBar from './AuthBar';
import tableService from 'services/tableService';
import registrationService from 'services/registrationService';
import 'assets/app.scss';
import { Grid, Alert } from '@mantine/core';
import { TableGroup as TableGroupType } from 'types/common';
import { useSettings } from '../../hooks/useSettings';

const Content: FC = () => {
    const { settings, loading: settingsLoading } = useSettings();
    const [email, setEmail] = useState('');
    const [code, setCode] = useState('');
    const [booked, setBooked] = useState<string[]>([]);
    const [booking, setBooking] = useState('');
    const [loading, setLoading] = useState(true);
    const [registered, setRegistered] = useState<number>();
    const [tableGroups, setTableGroups] = useState<TableGroupType[]>([]);
    const [blockedLocations, setBlockedLocations] = useState<string[]>([]);

    useEffect(() => {
        loadBooked();
        loadRegistered();
        loadTableGroups();
        loadBlocked();
    }, []);

    const loadTableGroups = () => {
        tableService
            .getAllTableGroups()
            .then(groups => {
                setTableGroups(groups);
            })
            .catch(err => {
                console.log(err);
            });
    };

    const loadBlocked = () => {
        tableService
            .getBlockedLocations()
            .then(locations => {
                setBlockedLocations(locations);
            })
            .catch(err => {
                console.log(err);
            });
    };

    const setBookingLocation = (location: string) => {
        setBooking(location);
    };

    const loadBooked = () => {
        tableService
            .allBooked()
            .then(res => {
                setBooked(res.data);
                setLoading(false);
            })
            .catch(err => {
                console.log(err);
                setLoading(false);
            });
    };

    const loadRegistered = () => {
        registrationService
            .count()
            .then(res => {
                setRegistered(res);
            })
            .catch(err => {
                console.log(err);
            });
    };

    const setAuth = (authEmail: string, authCode: string) => {
        setEmail(authEmail);
        setCode(authCode);
    };

    const toggle = (location: string) => {
        if (booking === location) {
            tableService
                .free(email, code)
                .then(() => {
                    setBookingLocation('-');
                    loadBooked();
                })
                .catch(err => {
                    console.log(err);
                });
        } else {
            tableService
                .book(email, code, location)
                .then(() => {
                    setBookingLocation(location);
                    loadBooked();
                })
                .catch(err => {
                    console.log(err);
                });
        }
    };

    const noteForNoTables = (freeAmount: number) => (
        <>
            {freeAmount === 0 && (
                <Alert color="blue" title="HUOM!">
                    Ilmoittautuneita on enemmän kuin tässä näkyviä pöytäpaikkoja.
                </Alert>
            )}
        </>
    );

    const reserved = booked.length;
    const blockedUnbooked = blockedLocations.filter(location => !booked.includes(location)).length;
    const free = (settings?.total ?? 0) - reserved - blockedUnbooked;

    return (
        <div style={{ color: 'whitesmoke' }}>
            {settingsLoading || settings?.bookingEnabled ? (
                <>
                    {loading || settingsLoading ? (
                        <Alert color="blue">(odota hetki ladataan tietoja...)</Alert>
                    ) : (
                        <div>
                            {noteForNoTables(free)}
                            <div style={{ marginTop: 10 }}>
                                <span style={{ marginBottom: 10 }}>
                                    Kirjoita sähköpostisi ja saamasi koodi, sen jälkeen varata vapaana olevan pöydän
                                    itsellesi.
                                    <br />
                                    Varauksen voi vaihtaa klikkaamalla toista pöytää tai poistaa klikkaamalla varattua
                                    pöytää.
                                    <br />
                                    Voit varata vain yhden pöydän.
                                </span>
                                <AuthBar setBooking={setBooking} setAuth={setAuth} booking={booking} />
                                <div style={{ marginBottom: 15, color: '#c6c6c6' }}>
                                    Vapaana paikkoja:{' '}
                                    <span>
                                        {free}/{settings?.total ?? 0} (varattuja: {reserved}
                                        {blockedUnbooked > 0 ? `, blokattuja: ${blockedUnbooked}` : ''})
                                    </span>
                                </div>
                                <div style={{ marginBottom: 15, color: '#a6a6a6' }}>
                                    Ilmoittautuneita: <span>{registered}</span>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            ) : null}
            <div className="table-clearfix">
                <h4>Värikoodit</h4>
                <Grid>
                    <Grid.Col span={3}>
                        <div className="table-legend table-free"></div>
                        <span style={{ display: 'inline-block' }}>Vapaa</span>
                    </Grid.Col>
                    <Grid.Col span={3}>
                        <div className="table-legend table-premium"></div>
                        <span style={{ display: 'inline-block' }}>Vapaa Siunattu paikka</span>
                    </Grid.Col>
                    <Grid.Col span={3}>
                        <div className="table-legend table-booking"></div>
                        <span style={{ display: 'inline-block' }}>Sinun pöytäsi</span>
                    </Grid.Col>
                    <Grid.Col span={3}>
                        <div className="table-legend table-booked"></div>
                        <span style={{ display: 'inline-block' }}>Varattu</span>
                    </Grid.Col>
                    <Grid.Col span={3}>
                        <div className="table-legend table-disabled"></div>
                        <span style={{ display: 'inline-block' }}>Blokkattu</span>
                    </Grid.Col>
                </Grid>
            </div>
            <SeatLayout
                tableGroups={tableGroups}
                booked={booked}
                booking={booking}
                toggle={toggle}
                blockedLocations={blockedLocations}
                disabledLocations={blockedLocations}
            />
        </div>
    );
};

export default Content;
